import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { useNavigate } from "react-router-dom";

export const useDuplicateJob = () => {
  const { toast } = useToast();
  const navigate = useNavigate();

  const duplicateJob = async (jobId: string) => {
    try {
      // Fetch the original job
      const { data: originalJob, error: fetchError } = await supabase
        .from('jobs')
        .select('*')
        .eq('id', jobId)
        .single();

      if (fetchError) throw fetchError;

      // Create a copy with modified fields
      const { id, created_at, updated_at, ...jobData} = originalJob;
      
      const newJob = {
        ...jobData,
        status: 'new' as const,
        archived_at: null,
      };

      const { data: createdJob, error: createError } = await supabase
        .from('jobs')
        .insert([newJob])
        .select()
        .single();

      if (createError) throw createError;

      toast({
        title: "Job duplicated",
        description: "Job has been successfully duplicated.",
      });

      navigate(`/job/${createdJob.id}`);
      return createdJob;
    } catch (error: any) {
      console.error('Error duplicating job:', error);
      toast({
        title: "Error",
        description: error.message || "Failed to duplicate job",
        variant: "destructive",
      });
      return null;
    }
  };

  return { duplicateJob };
};
